import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"spa"}/>
}
